import Login from '../pages/Login';
import Home from '../pages/Home';
import Propostas from '../pages/Propostas';
import RegPropostas from '../pages/RegPropostas';
import Grupo_Usuarios from '../pages/Grupo_Usuarios';
import RegGrupo_Usuarios from '../pages/RegGrupo_Usuarios';
import Usuarios from '../pages/Usuarios';
import RegUsuarios from '../pages/RegUsuarios';
import Vendedores from '../pages/Vendedores';
import RegVendedores from '../pages/RegVendedores';
import ChangePw from '../pages/ChangePw';
import ForgotPw from '../pages/ForgotPw';
import VendaDireta from '../pages/VendaDireta';
import VendaExterna from '../pages/VendaExterna';
import Pagamento from '../pages/Pagamento';
import PropostaAssociado from '../pages/propostaAssociado';
import Coberturas from '../pages/Coberturas';
import Financeiro from '../pages/Financeiro';
import ParceiroVenda from '../pages/Parceiro_Venda';
import RelatorioComissoes from '../pages/RelatorioComissoes';
import Bloquetos from '../pages/Bloquetos';
import Cadastre_se from '../pages/Cadastre_se';
import RegPropostaAssociado from '../pages/RegPropostaAssociado';


export const routes = [
    {
        path: '/forgotPw',
        component: ForgotPw,
        protected: false,
        exact: true,
        checkPermission: false,
        register: false
    },
    {
        path: '/cadastre_se',
        component: Cadastre_se,
        protected: false,
        exact: true,
        checkPermission: false,
        register: false
    },

    {
        path: '/changePw',
        component: ChangePw,
        protected: false,
        exact: true,
        checkPermission: false,
        register: false
    },

    {
        path: '/login',
        component: Login,
        protected: false,
        exact: true,
        checkPermission: false,
        register: false
    },
    {
        path: '/home',
        component: Home,
        protected: true,
        exact: true,
        checkPermission: false,
        register: false
    },
    {
        path: '/propostas',
        component: Propostas,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Clientes'
    },
    {
        path: '/propostas/registro',
        component: RegPropostas,
        protected: false,
        exact: true,
        checkPermission: false,
        register: true
    },
    {
        path: '/usuarios',
        component: Usuarios,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Usuários'
    },
    {
        path: '/usuarios/registro',
        component: RegUsuarios,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },
    {
        path: '/grupo_usuarios',
        component: Grupo_Usuarios,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Grupos de Usuários'
    },
    {
        path: '/grupo_usuarios/registro',
        component: RegGrupo_Usuarios,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },
    {
        path: '/vendedores',
        component: Vendedores,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Vendedores'
    },
    {
        path: '/vendedores/registro',
        component: RegVendedores,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },
    {
        path: '/vendadireta',
        component: VendaDireta,
        protected: false,
        exact: true,
        checkPermission: false,
        register: true
    },
    {
        path: '/vendaexterna',
        component: VendaExterna,
        protected: false,
        exact: true,
        checkPermission: false,
        register: true
    },
    {
        path: '/pagamento',
        component: Pagamento,
        protected: false,
        exact: true,
        checkPermission: false,
        register: true
    },
    {
        path: '/propostaAssociado',
        component: PropostaAssociado,
        protected: false,
        exact: true,
        checkPermission: false,
        register: true
    },
    {
        path: '/coberturas',
        component: Coberturas,
        protected: false,
        exact: true,
        checkPermission: false,
        register: true
    },
    {
        path: '/coberturas/cadastro',
        component: Coberturas,
        protected: false,
        exact: true,
        checkPermission: false,
        register: true
    },
    {
        path: '/financeiro',
        component: Financeiro,
        protected: false,
        exact: true,
        checkPermission: false,
        register: true
    },
    {
        path: '/Parceiro_Venda',
        component: ParceiroVenda,
        protected: false,
        exact: true,
        checkPermission: false,
        register: true
    },
    {
        path: '/Parceiro_Venda/contatos',
        component: ParceiroVenda,
        protected: false,
        exact: true,
        checkPermission: false,
        register: true
    },
    {
        path: '/RelatorioComissoes',
        component: RelatorioComissoes,
        protected: false,
        exact: true,
        checkPermission: false,
        register: true
    },
    {
        path: '/bloquetos',
        component: Bloquetos,
        protected: false,
        exact: true,
        checkPermission: false,
        register: true
    },
    {
        path: '/propostaAssociado/registro',
        component: RegPropostaAssociado,
        protected: false,
        exact: true,
        checkPermission: false,
        register: true
    },

];

export const fallbackRoute = Home

